import { render, staticRenderFns } from "./EditEventForm.vue?vue&type=template&id=51d2a935&"
import script from "./EditEventForm.vue?vue&type=script&lang=js&"
export * from "./EditEventForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports